import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import service from './service'
import customer from './customer'
import notification from './notification'
import serviceTracking from './service-tracking'
import invoice from './invoice'
import error from './error'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    user: user,
    service: service,
    customer: customer,
    notification: notification,
    serviceTracking: serviceTracking,
    invoice: invoice,
    error: error
  },
  state: {
    changePassword: false,
    startLoading: false,
    loading: false,
    startDataLoading: false,
    dataLoading: false,
    showNotification: false,
    notificationMessage: {
      title: '',
      text: '',
      type: ''
    }
  },
  mutations: {
    setChangePassword (state, payload) {
      state.changePassword = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setStartLoading (state, payload) {
      state.startLoading = payload
    },
    setDataLoading (state, payload) {
      state.dataLoading = payload
    },
    setStartDataLoading (state, payload) {
      state.startDataLoading = payload
    }
  },
  actions: {
    startLoading ({ commit, state }) {
      commit('setStartLoading', true)
      setTimeout(() => {
        if (state.startLoading === true) {
          commit('setLoading', true)
        }
      }, 1000)
    },
    stopLoading ({ commit }) {
      commit('setStartLoading', false)
      commit('setLoading', false)
    },
    startDataLoading ({ commit, state }) {
      commit('setStartDataLoading', true)
      setTimeout(() => {
        if (state.startDataLoading === true) {
          commit('setDataLoading', true)
        }
      }, 1000)
    },
    stopDataLoading ({ commit }) {
      commit('setStartDataLoading', false)
      commit('setDataLoading', false)
    }
  },
  getters: {
    changePassword (state) {
      return state.changePassword
    },
    loading (state) {
      return state.loading
    },
    dataLoading (state) {
      return state.dataLoading
    },
    startDataLoading (state) {
      return state.startDataLoading
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js